"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerControls = exports.BannerControlsDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
exports.BannerControlsDefaultProps = {
  items: [],
  showFirstBorder: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: ", ";\n    display: flex;\n    align-self: stretch;\n    align-items: stretch;\n    flex-direction: column;\n  "], ["\n    margin-top: ", ";\n    display: flex;\n    align-self: stretch;\n    align-items: stretch;\n    flex-direction: column;\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: 0;\n    ", "\n    flex-direction: row;\n  "], ["\n    margin-top: 0;\n    ", "\n    flex-direction: row;\n  "])), function (props) {
    return !props.showFirstBorder && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-left: ", ";\n    "], ["\n      margin-left: ", ";\n    "])), theme_1.theme.UNIT(4));
  })
});
var ControlStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-start;\n    padding-top: ", ";\n    margin-bottom: ", ";\n    ", ";\n    ", "\n  "], ["\n    display: flex;\n    align-items: flex-start;\n    padding-top: ", ";\n    margin-bottom: ", ";\n    ", ";\n    ", "\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.H_DOT_BG(), function (_a) {
    var isLast = _a.isLast;
    return isLast && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-bottom: 0;\n    "], ["\n      margin-bottom: 0;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    padding-left: ", ";\n    margin-right: ", ";\n    padding-top: 0;\n    margin-bottom: 0;\n    ", ";\n    ", "\n\n    ", "\n\n  "], ["\n    padding-left: ", ";\n    margin-right: ", ";\n    padding-top: 0;\n    margin-bottom: 0;\n    ", ";\n    ", "\n\n    ", "\n\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4), theme_1.theme.V_DOT_BG(), function (_a) {
    var isLast = _a.isLast;
    return isLast && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      margin-right: 0;\n    "], ["\n      margin-right: 0;\n    "])));
  }, function (_a) {
    var isFirst = _a.isFirst,
      showFirstBorder = _a.showFirstBorder;
    return isFirst && !showFirstBorder && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding-left: 0;\n      background: none;\n    "], ["\n      padding-left: 0;\n      background: none;\n    "])));
  }),
  desktop: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    padding-left: ", ";\n    margin-right: ", ";\n\n    ", "\n\n    ", "\n  "], ["\n    padding-left: ", ";\n    margin-right: ", ";\n\n    ", "\n\n    ", "\n  "])), theme_1.theme.UNIT(5), theme_1.theme.UNIT(5), function (_a) {
    var isFirst = _a.isFirst,
      showFirstBorder = _a.showFirstBorder;
    return isFirst && !showFirstBorder && (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      padding-left: 0;\n    "], ["\n      padding-left: 0;\n    "])));
  }, function (_a) {
    var isLast = _a.isLast;
    return isLast && (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      margin-right: 0;\n    "], ["\n      margin-right: 0;\n    "])));
  })
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Control: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ControlStyles)
};
var BannerControls = function (props) {
  var className = props.className,
    showFirstBorder = props.showFirstBorder;
  var items = (0, lodash_1.filter)(props.items);
  return items.length ? react_1.default.createElement(My.Container, {
    showFirstBorder: showFirstBorder,
    className: className
  }, items.map(function (item, index) {
    return react_1.default.createElement(My.Control, {
      key: "control-".concat(index),
      isLast: index === items.length - 1,
      isFirst: index === 0,
      showFirstBorder: showFirstBorder
    }, item);
  })) : null;
};
exports.BannerControls = BannerControls;
exports.BannerControls.defaultProps = exports.BannerControlsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;